import { IS_LOADING, SET_LOTS, SET_EXPANDED_LOT_ID } from "./siteMonitoringConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import { adaptLotForDb, adaptLotForMyOpen, adaptLotForOpenERP } from "./siteMonitoringCast";
import { deleteNote, synchronizeNotes } from "./noteActions";
import db from "../../db";

export function siteMonitoringsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "site_monitoring_lot",
        isLoading: value,
    };
}

export function setLotsAction(lots) {
    return {
        type: SET_LOTS,
        lots,
    };
}

export function setExpandedLotIdAction(expandedLotId) {
    return {
        type: SET_EXPANDED_LOT_ID,
        expandedLotId,
    };
}

export function getLots(siteMonitoring) {
    return (dispatch) => {
        dispatch(siteMonitoringsIsLoading(true));
        db.SiteMonitoringLot.filter((lot) => {
            return lot.affair_id === siteMonitoring.id;
        })
            .toArray()
            .then((lots) => {
                let transformedLots = [];
                lots.sort(sortByName).forEach((l) => transformedLots.push(adaptLotForMyOpen(l)));

                dispatch(setLotsAction(transformedLots));
                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : lotActions - getLots", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des lots !",
                    })
                );
                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

function sortByName(lotA, lotB) {
    if (lotA.name < lotB.name) return -1;

    if (lotA.name > lotB.name) return 1;

    return 0;
}

export function createLot(siteMonitoring, user) {
    return (dispatch) => {
        let newLot = {
            affair_id: siteMonitoring.id,
            name: "",
            description: "",
        };

        const headers = new Headers({ "Content-Type": "application/json" });

        let lotForOpenErp = adaptLotForOpenERP(newLot);

        const body = {
            lot: lotForOpenErp,
            userId: user.id,
        };

        dispatch(siteMonitoringsIsLoading(true));

        fetchWithTimeout("/api/v1/siteMonitorings/lots/create", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((newLotId) => {
                newLot.id = newLotId;
                db.SiteMonitoringLot.add(adaptLotForDb(newLot));
                dispatch(getLots(siteMonitoring));
                dispatch(setExpandedLotId(newLot.id));
                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : lotActions - createLot: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la création du lot",
                    })
                );

                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function deleteLot(siteMonitoring, lot, user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        let lotForOpenErp = adaptLotForOpenERP(lot);

        const body = {
            lot: lotForOpenErp,
            userId: user.id,
        };

        dispatch(siteMonitoringsIsLoading(true));

        fetchWithTimeout("/api/v1/siteMonitorings/lots/delete", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                lot.deleted = true;
                db.SiteMonitoringLot.delete(lot.id);

                dispatch(getLots(siteMonitoring));
                dispatch(setExpandedLotId(null));
                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : lotActions - deleteLot: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la suppression du lot",
                    })
                );

                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function saveLot(siteMonitoring, lot, user, withoutLoader = false) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        let lotForOpenErp = adaptLotForOpenERP(lot);

        const body = {
            lot: lotForOpenErp,
            userId: user.id,
        };

        if (!withoutLoader) dispatch(siteMonitoringsIsLoading(true));

        fetchWithTimeout("/api/v1/siteMonitorings/lots/save", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                db.SiteMonitoringLot.update(lot.id, adaptLotForDb(lot));

                dispatch(getLots(siteMonitoring));
                dispatch(setExpandedLotId(lot.id));
                if (!withoutLoader) dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : lotActions - saveLot: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la sauvegarde du lot",
                    })
                );

                if (!withoutLoader) dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function setExpandedLotId(expandedLotId) {
    return (dispatch) => {
        dispatch(setExpandedLotIdAction(expandedLotId));
    };
}

export function synchronizeLots(serverSiteMonitoring, user) {
    return (dispatch) => {
        db.SiteMonitoringLot.filter((lot) => {
            return lot.affair_id === serverSiteMonitoring.id;
        })
            .toArray()
            .then((dbLots) => {
                let dbLotsAlwaysInOpenErp = [];

                serverSiteMonitoring.lot_ids.forEach((sl) => {
                    let transformedServerLot = adaptLotForMyOpen(sl);

                    let dbLot = dbLots.find((dbi) => dbi.id === sl.id);

                    dbLotsAlwaysInOpenErp = dispatch(
                        synchronizeLot(dbLot, transformedServerLot, dbLotsAlwaysInOpenErp, serverSiteMonitoring, user)
                    );
                });

                dbLots.forEach((dbl) => {
                    if (!dbLotsAlwaysInOpenErp.includes(dbl)) {
                        deleteLotInDb(dbl);
                    }
                });

                dispatch(siteMonitoringsIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : lotActions - synchronizeLots", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la synchronisation des lots !",
                    })
                );
                dispatch(siteMonitoringsIsLoading(false));
            });
    };
}

export function deleteLotInDb(lot) {
    db.SiteMonitoringLot.delete(lot.id);

    db.SiteMonitoringNote.filter((note) => {
        return note.lot_id === lot.id;
    })
        .toArray()
        .then((dbNotes) => {
            dbNotes.forEach((dbn) => {
                deleteNote(dbn);
            });
        });
}

export function synchronizeLot(dbLot, transformedServerLot, dbLotsAlwaysInOpenErp, siteMonitoring, user) {
    return (dispatch) => {
        transformedServerLot.affair_id = siteMonitoring.id;

        if (dbLot) {
            dbLotsAlwaysInOpenErp.push(dbLot);
            db.SiteMonitoringLot.update(transformedServerLot.id, adaptLotForDb(transformedServerLot));
        } else {
            db.SiteMonitoringLot.add(adaptLotForDb(transformedServerLot));
        }

        dispatch(synchronizeNotes(transformedServerLot, siteMonitoring, user));

        return dbLotsAlwaysInOpenErp;
    };
}
